import { HTMLProps, useCallback } from "react";
import { useMap } from "react-map-gl/mapbox";
import { LngLatBoundsLike } from "mapbox-gl";
import { cn } from "@/utils/helpers";
import { getLang } from "@/utils/selectors";
import Button from "@/components/common/Button";
import Overlay from "@/components/common/Overlay";
import SvgIconZoom from "@/components/common/Svg/components/SvgIconZoom";
import { MAP_BOUNDS_USA, MAP_DEFAULT_PADDING, MAP_FLY_DURATION, MAP_FLY_ZOOM, MAP_ZOOM_TYPES } from "../utils/constants";
import styles from "../Map.module.css"

export interface MapControlsProps extends HTMLProps<HTMLElement> {}

export default function MapControls({
	className
} : MapControlsProps) {
	const { default: map } = useMap();

	const zoomToMe = useCallback(() => {
		navigator.geolocation.getCurrentPosition((position) => {
			map?.flyTo({
				zoom: MAP_FLY_ZOOM,
				center: [
					position?.coords?.longitude,
					position?.coords?.latitude
				],
				duration: MAP_FLY_DURATION
			})
		},
		(error) => {
			console.error(error);
		},
		{
			enableHighAccuracy: true
		});
	}, [map]);

	const fitBounds = useCallback((bounds: LngLatBoundsLike) =>
		map?.fitBounds(bounds, {
			padding: MAP_DEFAULT_PADDING,
			duration: MAP_FLY_DURATION
		})
	, [map]);

	const handleZoomClick = useCallback((type: string) => {
		switch(type) {
			case "me":
				zoomToMe();
				break;
			case "fit":
				fitBounds(MAP_BOUNDS_USA);
				break;
			case "in":
				map?.zoomIn();
				break;
			case "out":
				map?.zoomOut();
				break;
			// case "ak":
			// 	fitBounds(MAP_BOUNDS_AK);
			// 	break;
			// case "hi":
			// 	fitBounds(MAP_BOUNDS_HI);
			// 	break;
		}
	}, [map]);

	return (
		<Overlay
			className={cn(
				styles.MapControls,
				className
			)}
		>
			<div
				className={styles.MapControlsButtons}
			>
				{MAP_ZOOM_TYPES.map(type =>
					<Button
						key={type}
						square={true}
						label={getLang("map", "controls", type)}
						title={getLang("map", "controls", type)}
						onClick={() => handleZoomClick(type)}
					>
						<SvgIconZoom
							type={type}
						/>
					</Button>
				)}
			</div>
		</Overlay>
	)
}